import { numberCalc } from './helper.mjs';
class Formulas {
    constructor() {
        this._ = [];
        this.length = 0;
    }
    setData(d) {
        this._ = d.map(it => { 
            return new Formula(it);
        }); 
        this.length = this._.length;
    }
    getData() {
        return this._.map(it => it.getData());
    }
    add(d) { 
            const f = new Formula(d);
            this._.push(f);
            this.length++;
            return f; 
    }
    removeAt(i) { 
        if (i !== -1) {
            this._.splice(i, 1);
            this.length--;
        }
    }
    apply(index) {
        this._[index].apply();
    }
    applyAll() {
        this._.forEach(f => f.apply());
    }
    getIndexof(d) {
        return this._.findIndex(f =>
            (!d.key || f.key === d.key) &&
            (!d.target || f.target === d.target) &&
            (!d.source || (
                f.source.length === d.source.length &&
                f.source.every((s, i) => s === d.source[i])
            ))
        );
    }
    getNode(i) {
        if (i === undefined) {
            return this._[0];
        }
        else if (i === -1) {
            return null;
        } else {
            return this._[i];
        }
    } 
    getByCode(code) {
        const index = this._.findIndex(f => f.source.includes(code));
        return this.getNode(index);
    }
    getFormulaWith(c) {
        const index = this._.findIndex(f => arraysMatch(f.source,c));
        return this.getNode(index);
    }
}

class Formula {
    constructor({ key, formula, target } = {}) { 
        this.key = key;
        this.formula = formula;
        this.target = target;
        this.result = this.getCodes(target);
        this.source = this.getCodes(formula); 
    }
    getData() {
        const { key, formula, target } = this; 
        return { key, target, formula };
    } 
    async apply(vals) {
        const { key, formula, source, result } = this;
        const s_list = []; 
        const t_list = []; 
        for (var v of vals) {
            const s = v.getByCodes(source);
            const t = v.getByCodes(result);
            s_list.push(...s);
            t_list.push(...t);
        }

        if (key == 'custom') {
            let expr = formula;
             
            for (const item of s_list) {
                const code = item.code;
                const value = item.getValue();
                expr = expr.replaceAll(`[${code}]`, value ?? 0);
            }
             
            let resultValue = 0;
            try { 
                resultValue = Function(`"use strict"; return (${expr})`)();
            } catch (e) {
                console.error('Invalid formula:', expr, e);
            }

            t_list.forEach(item => item.setValue(resultValue));
        }
        else {
            const entry = formulam[key];
            if (!entry) throw new Error(`Formula '${key}' not found`);

            const values = s_list.map(item => item.getValue());
            const resultValue = entry.render(values);

            t_list.forEach(item => item.setValue(resultValue));
        }
          
    }
    getCodes(str) { 
        const k = [];
        const tokens = str.split(/(\[[^\]]+\])/);
        tokens.forEach(t => {
            if (t.startsWith('[') && t.endsWith(']')) {
                const key = t.slice(1, -1);  
                k.push(key);
            }  
        });
        return k;
    }
}
function arraysMatch(a, b) {
    if (a.length !== b.length) return false;
    return [...a].sort().join() === [...b].sort().join();
}
const baseFormulas = [
    {
        key: 'sum', 
        render: ary => ary.reduce((a, b) => numberCalc('+', a, b), 0),
    },
    {
        key: 'average', 
        render: ary => ary.reduce((a, b) => Number(a) + Number(b), 0) / ary.length,
    },
    {
        key: 'max', 
        render: ary => Math.max(...ary.map(v => Number(v))),
    },
    {
        key: 'min', 
        render: ary => Math.min(...ary.map(v => Number(v))),
    },
    {
        key: 'if', 
        render: ([b, t, f]) => (b ? t : f),
    },
    {
        key: 'and', 
        render: ary => ary.every(it => it),
    },
    {
        key: 'or', 
        render: ary => ary.some(it => it),
    },
    {
        key: 'concat', 
        render: ary => ary.join(''),
    }
     
];

//const formulas = baseFormulas;
 
const formulam = {};
baseFormulas.forEach((f) => {
    formulam[f.key] = f;
});

export default {
};

export {
    formulam,
    //formulas,
    baseFormulas,
    Formulas
};